import React from "react";
import { DialogActions } from "@mui/material";

const DSDialogActions = (props: React.ComponentProps<typeof DialogActions>) => {
  return <DialogActions {...props} sx={{ ...props.sx, padding: 3 }} />;
};

export default DSDialogActions;
